import type { RegisteredComponent } from '@/libs/builder/sdk-react'

export const registeredPagueVelozBlogComponents: RegisteredComponent[] = []
